import React from "react";
import { ReactComponent as FacebookIcon } from "../../assets/Icons/facebook.svg";
import { ReactComponent as PinterestIcon } from "../../assets/Icons/pinterest.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/Icons/youtube.svg";
import { ReactComponent as InstagramIcon } from "../../assets/Icons/instagram.svg";
import { ReactComponent as TwitterIcon } from "../../assets/Icons/twitter.svg";
import { ReactComponent as LinkedInIcon } from "../../assets/Icons/linkedIn.svg";
import { ReactComponent as AppStore } from "../../assets/Icons/appstore.svg";
import { ReactComponent as PlayStore } from "../../assets/Icons/playstore.svg";
import { ReactComponent as DownloadApk } from "../../assets/Icons/downloadapk.svg";
import { ReactComponent as TikTokIcon } from "../../assets/Icons/tiktok.svg";
import { ReactComponent as SnapchatIcon } from "../../assets/Icons/snapchat.svg";
import { ReactComponent as TelegramIcon } from "../../assets/Icons/telegram.svg";
import { ReactComponent as WhatsappIcon } from "../../assets/Icons/whatsapp.svg";
import { ReactComponent as FacebookMessengerIcon } from "../../assets/Icons/facebook-messenger.svg";
import { ReactComponent as TumblrIcon } from "../../assets/Icons/tumblr.svg";
import { ReactComponent as QuoraIcon } from "../../assets/Icons/quora.svg";
import { ReactComponent as DiscordIcon } from "../../assets/Icons/discord.svg";
import { ReactComponent as ThreadsIcon } from "../../assets/Icons/threads.svg";
import { ReactComponent as RedditIcon } from "../../assets/Icons/reddit.svg";
import DownloadAPKModal from "../Modals/DownloadAPKModal";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Translate from "../Multilanguage/Translate";
const Footer = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const [downloadModal, setDownloadModal] = useState(false);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const navigate = useNavigate();
  const copyrightText = projectInfo?.projectConfig?.config?.COPYRIGHT_TEXT;
  const copyrightDocumentLink = projectInfo?.projectConfig?.config?.COPYRIGHT_DOCUMENT;
  const pubid = projectInfo?.projectConfig?.pubid;
  const kids = projectInfo?.projectConfig?.config?.TEMPLATE === 'TEMPLATE_12';

  const linkHandler = (data) => {
    if (data?.seo_url) {
      navigate(data?.seo_url);
    } else if (data?.title == 'refund_policy') {
      window.open(data?.link, "_self");
    } else if (data?.link) {
      window.open(data?.link);
    }
  };
  
  return (
    <div className={`footerContainer ${isRTL ? "rtl" : ""} ${kids ? "kids" : ""}`}>
      <div className="wrapper">
      {downloadModal && <DownloadAPKModal setDownloadModal={setDownloadModal} />}
        <div className="topContainer">
          <div className="left">
            {(pubid !== 50167 && !kids) && <div className="logoContainer">
              <img src={projectInfo?.projectConfig?.config?.LOGO} alt="Logo" />
            </div>}
          </div>
          <div className="right">
            <ul className="social">
              {projectInfo?.projectConfig?.config?.FACEBOOK && (
                <li  title="Facebook"
                onClick={() =>
                  window.open(
                    projectInfo?.projectConfig?.config?.FACEBOOK,
                    "blank"
                  )
                }
              >
                <FacebookIcon />
              </li>
              )}

              {projectInfo?.projectConfig?.config?.INSTAGRAM && (
                <li  title="Instagram"
                  onClick={
                    () =>
                    window.open(
                      projectInfo?.projectConfig?.config?.INSTAGRAM,
                      "blank"
                    )
                  }
                >
                  <InstagramIcon />
                </li>
              )}
              {projectInfo?.projectConfig?.config?.TWITTER && (
                <li  title="Twitter"
                  onClick={
                    () => 
                    window.open(
                      projectInfo?.projectConfig?.config?.TWITTER,
                      "blank"
                    )
                  }
                >
                  <TwitterIcon />
                </li>
              )}
              {projectInfo?.projectConfig?.config?.LINKEDIN && (
                <li  title="LinkedIn"
                  onClick={
                    () => 
                    window.open(
                      projectInfo?.projectConfig?.config?.LINKEDIN,
                      "blank"
                    )
                  }
                >
                  <LinkedInIcon />
                </li>
              )}
              {projectInfo?.projectConfig?.config?.PINTEREST && (
                <li  title="Pinterest"
                onClick={
                  () => 
                  window.open(
                    projectInfo?.projectConfig?.config?.PINTEREST,
                    "blank"
                  )
                }
                >
                  <PinterestIcon />
                </li>
              )}
              {projectInfo?.projectConfig?.config?.YOUTUBE && (
                <li  title="YouTube"
                onClick={
                  () => 
                  window.open(
                    projectInfo?.projectConfig?.config?.YOUTUBE,
                    "blank"
                  )
                }
                >
                  <YoutubeIcon />
                </li>
              )}
              {projectInfo?.projectConfig?.config?.TIKTOK && (
                <li  title="TikTok"
                onClick={
                  () => 
                  window.open(
                    projectInfo?.projectConfig?.config?.TIKTOK,
                    "blank"
                  )
                }
                >
                  <TikTokIcon/>
                </li>
              )}
              {projectInfo?.projectConfig?.config?.SNAPCHAT && (
                <li  title="Snapchat" onClick={ () => window.open( projectInfo?.projectConfig?.config?.SNAPCHAT, "blank" )}>
                  <SnapchatIcon/>
                </li>
              )}
              {projectInfo?.projectConfig?.config?.TELEGRAM && (
                <li  title="Telegram" onClick={ () => window.open( projectInfo?.projectConfig?.config?.TELEGRAM, "blank" )}>
                  <TelegramIcon/>
                </li>
              )}
               {projectInfo?.projectConfig?.config?.WHATSAPP && (
                <li  title="WhatsApp" onClick={ () => window.open( projectInfo?.projectConfig?.config?.WHATSAPP, "blank" )}>
                  <WhatsappIcon/>
                </li>
              )}
               {projectInfo?.projectConfig?.config?.FACEBOOKMESSENGER && (
                <li   title="Messenger" onClick={ () => window.open( projectInfo?.projectConfig?.config?.FACEBOOKMESSENGER, "blank" )}>
                  <FacebookMessengerIcon/>
                </li>
              )}
               {projectInfo?.projectConfig?.config?.TUMBLR && (
                <li   title="Tumblr" onClick={ () => window.open( projectInfo?.projectConfig?.config?.TUMBLR, "blank" )}>
                  <TumblrIcon/>
                </li>
              )}
                {projectInfo?.projectConfig?.config?.QUORA && (
                <li  title="Quora" onClick={ () => window.open( projectInfo?.projectConfig?.config?.QUORA, "blank" )}>
                  <QuoraIcon/>
                </li>
              )}
               {projectInfo?.projectConfig?.config?.DISCORD && (
                <li  title="Discord" onClick={ () => window.open( projectInfo?.projectConfig?.config?.DISCORD, "blank" )}>
                  <DiscordIcon/>
                </li>
              )}
               {projectInfo?.projectConfig?.config?.THREADS  && (
                <li  title="Threads" onClick={ () => window.open( projectInfo?.projectConfig?.config?.THREADS , "blank" )}>
                  <ThreadsIcon/>
                </li>
              )}
               {projectInfo?.projectConfig?.config?.REDDIT  && (
                <li  title="Reddit" onClick={ () => window.open( projectInfo?.projectConfig?.config?.REDDIT , "blank" )}>
                  <RedditIcon/>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="centerContainer">
          <div className="informationContainer">
            {kids && (
              <div className="items logoItem">
                <div className="logoContainer">
                  <img src={projectInfo?.projectConfig?.config?.LOGO} alt="Logo" />
                </div>
              </div>
            )}
            {projectInfo?.projectConfig?.config?.WEBSITE_FOOTERS?.map((data, index) => (
              <div className="items">
                <h6 className="heading"><Translate textKey={data.title} /></h6>
                <ul>
                  {data?.items?.map((item, index) => (
                    <li>
                      <span onClick={() => linkHandler(item)}><Translate textKey={item.title} /></span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bottomContainer">
        <div className="stores">
          {projectInfo?.projectConfig?.config?.IOS_APP_STORE_URL && (
            <AppStore onClick={() => window.open(projectInfo?.projectConfig?.config?.IOS_APP_STORE_URL, "blank")} />
          )}
          {projectInfo?.projectConfig?.config?.ANDROID_PLAY_STORE_URL && (
            <PlayStore
              onClick={() => window.open(projectInfo?.projectConfig?.config?.ANDROID_PLAY_STORE_URL, "blank")}
            />
          )}
          {projectInfo?.projectConfig?.config?.ANDROID_APK_LINK && (
            <DownloadApk
              onClick={()=>setDownloadModal(true)}
            />
          )}
        </div>

        <p>
          <a href={copyrightDocumentLink} target="_blank" >
            {copyrightText}
          </a>
        </p>

        <p><Translate textKey={'all_rights_reserved'} /></p>
        {projectInfo?.projectConfig?.config?.FOOTER_PAYMENTS_REQUIRED === "true" && (
          <div className="typeOfPayments">
            <i className="fa-brands fa-2x fa-cc-discover"></i>
            <i class="fa-brands fa-2x fa-cc-mastercard"></i>
            <i className="fa-brands fa-2x fa-cc-paypal"></i>
            <i className="fa-brands fa-2x fa-cc-visa"></i>
            <i class="fa-solid fa-globe"></i>
          </div>
        )}
      </div>
    </div>
  );
};

export default Footer;
